import React, { useState } from 'react';
import { Info } from 'lucide-react';
import { SCREEN_TOURS } from './toursData';
import ScreenTourModal from './ScreenTourModal';

interface ScreenTourButtonProps {
  screenKey: string;
  variant?: 'subtle' | 'pill' | 'header';
  /** Modo compacto: exibe apenas o ícone ⓘ sem o texto, ideal para headers estreitos */
  compact?: boolean;
  className?: string;
}

export default function ScreenTourButton({ 
  screenKey, 
  variant = 'header',
  compact = false,
  className = '' 
}: ScreenTourButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const tour = SCREEN_TOURS[screenKey];

  if (!tour) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className={`inline-flex items-center gap-1.5 rounded-xl text-xs font-semibold text-zinc-700 bg-zinc-100 hover:bg-zinc-200/80 hover:text-zinc-900 border border-zinc-200/90 transition-all active:scale-95 cursor-pointer shadow-2xs ${
          compact ? 'px-2 py-1.5' : 'px-3 py-1.5'
        } ${className}`}
        title={`Como usar: ${tour.screenTitle}`}
        aria-label={`Como usar: ${tour.screenTitle}`}
      >
        <div className="w-4 h-4 rounded-full bg-zinc-200 border border-zinc-300 text-zinc-700 flex items-center justify-center shrink-0">
          <Info className="w-3 h-3 stroke-[2.5]" />
        </div>
        {!compact && (
          <span className="truncate hidden sm:inline">Como usar esta tela</span>
        )}
      </button>

      <ScreenTourModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        tour={tour}
      />
    </>
  );
}
